module.exports = {
  originalState: { api: 'originalState', human: 'Originalzustand' },
  tuned: { api: 'tuned', human: 'Baulich verändert' },
  plannedTuning: { api: 'plannedTuning', human: 'Bauliche Veränderung geplant' }// HSS-731 plannedTuning is hidden in client
}
